export default function RentalSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
            Rental Services
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            We Rent <strong>Real Estate</strong>
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            We rent houses and apartments in El Paso, Texas. We accept Section 8, YMCA, HUDVASH, and other programs. We have rentals in all price ranges.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 md:order-1">
            <img
              src="https://public.readdy.ai/ai/img_res/f4035c6d003244a30cb7b39c20388eac.jpg"
              alt="Rental Properties"
              className="w-full h-[400px] object-cover rounded-2xl shadow-xl"
              onError={(e) => {
                const target = e.currentTarget as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>

          {/* Content */}
          <div className="order-1 md:order-2">
            <div className="space-y-6">
              {/* Houses */}
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-home-4-fill text-teal-600 text-2xl" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">We Rent Houses</h3>
                  <p className="text-gray-700">
                    Quality single-family homes available for rent throughout El Paso. Find the perfect house for your family.
                  </p>
                </div>
              </div>

              {/* Apartments */}
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-fill text-teal-600 text-2xl" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">We Rent Apartments</h3>
                  <p className="text-gray-700">
                    Comfortable apartments in various locations. From studios to multi-bedroom units, we have options for everyone.
                  </p>
                </div>
              </div>

              {/* Programs */}
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-fill text-teal-600 text-2xl" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">We Accept Programs</h3>
                  <p className="text-gray-700">
                    We proudly accept Section 8, YMCA, HUDVASH, and other assistance programs. Everyone deserves a quality home.
                  </p>
                </div>
              </div>

              {/* Price Ranges */}
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-price-tag-3-fill text-teal-600 text-2xl" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">All Price Ranges</h3>
                  <p className="text-gray-700">
                    Rentals available in all price ranges to fit your budget. Affordable housing solutions for every family.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <a
                href="tel:+19152065814"
                className="inline-flex items-center gap-2 px-8 py-4 bg-teal-600 text-white font-semibold rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-xl" aria-hidden="true"></i>
                Call About Rentals
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
